import React from "react";

const ItemCount = ({ count }) => {
  return (
    <>
      {count !== 0 && (
        <span
          style={{
            background: "#1a71f6",
            borderRadius: "50%",
            marginLeft: "10px",
            width: "22px",
            color: "#fff",
          }}
        >
          {count}
        </span>
      )}
    </>
  );
};

export default ItemCount;
